import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import SearchResults from './components/SearchResults/SearchResults'
import store from 'js/store';

export default function (el) {
  const cardsHolder = el.querySelector('[data-section="cards-holder"]');
  const root = ReactDOM.createRoot(cardsHolder || el);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <SearchResults />
      </Provider>
    </React.StrictMode>
  );
}
 